module.exports = __webpack_public_path__ + "static/media/box.7d4fa795.svg";